import React from 'react';

type BadgeProps = {
  text: string;
  color?: 'blue' | 'green' | 'red' | 'yellow' | 'gray' | 'indigo' | 'purple' | 'pink';
  size?: 'xs' | 'sm' | 'md';
};

const Badge: React.FC<BadgeProps> = ({ text, color = 'blue', size = 'xs' }) => {
  const colorClasses = {
    blue: 'bg-blue-100 text-blue-800',
    green: 'bg-green-100 text-green-800',
    red: 'bg-red-100 text-red-800',
    yellow: 'bg-yellow-100 text-yellow-800',
    gray: 'bg-gray-100 text-gray-800',
    indigo: 'bg-indigo-100 text-indigo-800',
    purple: 'bg-purple-100 text-purple-800',
    pink: 'bg-pink-100 text-pink-800'
  };

  const sizeClasses = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base'
  };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full font-medium ${colorClasses[color]} ${sizeClasses[size]}`}
    >
      {text}
    </span>
  );
};

export default Badge;
